import { render, staticRenderFns } from "./second.vue?vue&type=template&id=6ae5bd51&scoped=true&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"
import style0 from "./second.vue?vue&type=style&index=0&id=6ae5bd51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5bd51",
  null
  
)

export default component.exports